import React, { useState }  from "react";
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardText,
    CardFooter,
    Row,
    Col,
    Label,
    Input,
    ButtonGroup,
    Button
} from 'reactstrap';
import { Dropdown } from 'semantic-ui-react';
import { TranslatableFieldWithInput } from '../../../../../../components';
import { Utils } from '../../../../../../services';

import './ChoicesField.css';

const ChoicesField = (props) => {
    const { t, i18n } = useTranslation();
    const { choices, refs, onAdd, onRemove, onEdit, onSave } = props;

    const addChoice = () => {
        return onAdd && onAdd();
    };

    const removeChoice = (index) => {
        return onRemove && onRemove(index);
    };

    const setChoiceLabel = (index, label) => {
        return onEdit && onEdit(index, label);
    };

    if (refs?.length > 0) {
        const options = refs.map(r => ({
            key: r.id,
            text: Utils.localized_or_fallback(r.name, i18n.language),
            value: r.id,
        })).sort((a, b) => a.text.localeCompare(b.text));

        const onChange = (e, data) => {
            const values = data.value;
            const selection = values.map(id => refs.find(ref => ref.id === id));
            onSave(selection?.map(ref => ({
                ref_id: ref.id,
                label: ref.name
            })) || []);
        };

        return <Dropdown
            options={ options }
            value={ choices?.map(c => c.ref_id) }
            onChange={ onChange }
            fluid
            multiple
            selection
            search
            clearable
        />;
    }

    return (
        <Card className="ChoicesField h-auto">
            <CardText>
                <Row>
                    <Col>
                        {choices?.map((choice, i) => (
                            <div className="choiceWrapper">
                                <TranslatableFieldWithInput name={choice.label} type="text" onChange={ label => setChoiceLabel(i ,label) } />
                                <Button type="button" color="danger" onClick = { () => removeChoice(i) }>
                                    <span>
                                        <i className="fa fa-trash"></i>
                                    </span>
                                </Button>
                            </div>
                        ))}
                    </Col>
                </Row>
            </CardText>
            <CardFooter>
                <Row>
                    <Col>
                        <Button type="button" color="info" onClick = { () => addChoice() }>
                            <span>
                                <i className="fa fa-plus"></i>&nbsp;{t("common.add")}
                            </span>
                        </Button>
                    </Col>
                </Row>
            </CardFooter>
        </Card>
    );
};

export default ChoicesField;
